export default function (config) {
    const session = localStorage.getItem('session')
    if(session){
      config.headers.Authorization =  JSON.parse(session).id_token || null
    }
    config.headers.Authorization =  "eyJub25jZSI6ICJNRFk0T1dNeE16Y3RZelZqTlMwMFpERTVMV1l5Wm1ZdE5HSmpOemhqTlRCbFl6STAiLCAidGltZXN0YW1wIjogIjIwMTctMTItMTNUMTU6Mzg6MzIuMDAwWiIsICJ1c2VyX3V1aWQiOiAiMWI0YjkwYTYtZmIwNS00ZTA4LTgwN2MtZWFlZjUwYTRiYzM5In0="
    return config
  }
